export const V2_CLAIM_CODE_ENDPOINT = '/v1/profiles/{profileId}/redeemBenefits/code';
export const V2_SELECT_BENEFIT_ENDPOINT = '/v1/profiles/global/webservices/redeem/api/{profileId}/redeemBenefits/selectableBenefits/{code}';
export const enum STATUS {
    SUCCESS = 'SUCCESS',
    GENERIC_ERROR = 'GENERIC_ERROR',
    INVALID_CODE = 'INVALID_CODE',
    CODE_ALREADY_REDEEMED = 'CODE_ALREADY_REDEEMED',
    USER_ALREADY_REDEEMED = 'USER_ALREADY_REDEEMED',
    NOT_ELIGIBLE = 'NOT_ELIGIBLE_BY_COUNTRY',
    AGE_RESTRICTION = 'AGE_RESTRICTION',
    ADDITIONAL_INFO = 'REQUIRE_ADDITIONAL_INFO',
    PROFILE_NOT_LINKED = 'PROFILE_NOT_LINKED',
    MAINTENANCE_ERROR = 'MAINTENANCE_ERROR'
}

export const SAVE_REDEMPTION_PLATFORMS = 'SAVE_REDEMPTION_PLATFORMS' as const;
export const SAVE_BENEFITS = 'SAVE_BENEFITS' as const;

export enum HTTP_CODES {
    BAD_REQUEST = 400,
    INVALID_TICKET = 401,
    INVALID_CLIENT = 403,
    NOT_FOUND = 404,
    TOO_MANY_REQUESTS = 429,
    SERVER_ERROR = 500
}

export enum ERROR_CODES {
    INVALID_CODE = 400002,
    INVALID_PLATFORM = 400003,
    PROFILE_NOT_MATCH = 400004,
    NOT_ELIGIBLE = 400100,
    CODE_NOT_ACTIVE = 400201,
    CODE_NOT_AVAILABLE = 400202,
    CODE_EXPIRED = 400203,
    BENEFIT_NOT_SELECTED = 400205,
    CODE_LIMIT_REACHED = 400301,
    USER_LIMIT_REACHED = 400302,
    INVALID_TICKET = 401001,
    TICKET_EXPIRED = 401002,
    CLIENT_NOT_ALLOWED = 403001,
    CLIENT_CODE_NOT_ALLOWED = 403002,
    CODE_NOT_FOUND = 404001,
    OVER_USED = 429001,
    OVER_USED_IP = 429002,
    OVER_USED_USER = 429003,
    INTERNAL_SERVER_ERROR = 500000,
    EXTERNAL_SERVER_ERROR = 500001
}
